import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { clearEmptyProperties, mapCheckbox } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { DatePeriodValidation } from '@validators/date-period-validation';
import { DateValidation } from '@validators/date.validation';
import * as moment from 'moment';
import { debounceTime, tap } from 'rxjs/operators';
import english from '../../maintenances/i18n/en.json';
import spanish from '../../maintenances/i18n/es.json';
import portuguese from '../../maintenances/i18n/pt.json';
import { ReportFilterApi } from './services/report-filter-api.service';
import { ReportFilterState } from './services/report-filter-state.service';
var FiltersComponent = /** @class */ (function () {
    function FiltersComponent(fuseTranslationLoaderService, filterStateService, filtersQueries, formBuilder) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.filterStateService = filterStateService;
        this.filtersQueries = filtersQueries;
        this.formBuilder = formBuilder;
        this.segments = [];
        this.companies = [];
        this.locationsGroups = [];
        this.maintenanceTypes = [];
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FiltersComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.filtersQueries.getFiltersData()];
                    case 1:
                        data = _a.sent();
                        this.segments = data.segments;
                        this.companies = data.companies;
                        this.locationsGroups = data.locationsGroups;
                        this.maintenanceTypes = data.maintenanceTypes;
                        this.filtersForm = this.formBuilder.group({
                            openedAtGte: [moment().subtract('1', 'month').startOf('days'), DateValidation.validate],
                            openedAtLte: [moment().endOf('days'), DateValidation.validate],
                            scheduledAtGte: [null, DateValidation.validate],
                            scheduledAtLte: [null, DateValidation.validate],
                            closedAtGte: [null, DateValidation.validate],
                            closedAtLte: [null, DateValidation.validate],
                            locationId: new FormControl(),
                            locationsGroups: new FormArray(this.locationsGroups.map(function () { return new FormControl(false); })),
                            segments: new FormArray(this.segments.map(function () { return new FormControl(false); })),
                            maintenanceTypes: new FormArray(this.maintenanceTypes.map(function () { return new FormControl(false); })),
                            companies: new FormControl([])
                        }, {
                            validators: DatePeriodValidation.validate(['openedAt', 'closedAt', 'scheduledAt'])
                        });
                        this.filtersForm.valueChanges.pipe(debounceTime(500))
                            .subscribe(function () {
                            if (!_this.filtersForm.valid) {
                                return;
                            }
                            var openedAtGte = _this.filtersForm.value.openedAtGte;
                            var openedAtLte = _this.filtersForm.value.openedAtLte;
                            var scheduledAtGte = _this.filtersForm.value.scheduledAtGte;
                            var scheduledAtLte = _this.filtersForm.value.scheduledAtLte;
                            var closedAtGte = _this.filtersForm.value.closedAtGte;
                            var closedAtLte = _this.filtersForm.value.closedAtLte;
                            _this.filterStateService.query = {
                                openedAt_gte: openedAtGte && openedAtGte.startOf('day').format(),
                                openedAt_lte: openedAtLte && openedAtLte.endOf('day').format(),
                                scheduledAt_gte: scheduledAtGte && scheduledAtGte.startOf('day').format(),
                                scheduledAt_lte: scheduledAtLte && scheduledAtLte.endOf('day').format(),
                                closedAt_gte: closedAtGte && closedAtGte.startOf('day').format(),
                                closedAt_lte: closedAtLte && closedAtLte.endOf('day').format(),
                                typeId_in: mapCheckbox(_this.filtersForm.value.maintenanceTypes, _this.maintenanceTypes, 'id'),
                                segmentId_in: mapCheckbox(_this.filtersForm.value.segments, _this.segments, 'id'),
                                locationGroupId_in: mapCheckbox(_this.filtersForm.value.locationsGroups, _this.locationsGroups, 'id'),
                                locationId_in: _this.filtersForm.value.locationId,
                                companyId_in: _this.filtersForm.value.companies
                            };
                            if (_this.filtersForm.value.openedAtGte) {
                                _this.filterStateService.query.openedAt_gte = _this.filtersForm.value.openedAtGte.startOf('day').format();
                            }
                            else {
                                _this.filterStateService.query.openedAt_gte = moment().subtract('1', 'month').startOf('days').format();
                                _this.filtersForm.get('openedAtGte').setValue(moment().subtract('1', 'month').startOf('days'));
                            }
                            if (_this.filtersForm.value.openedAtLte) {
                                _this.filterStateService.query.openedAt_lte = _this.filtersForm.value.openedAtLte.startOf('day').format();
                            }
                            else {
                                _this.filterStateService.query.openedAt_lte = moment().endOf('days').format();
                                _this.filtersForm.get('openedAtLte').setValue(moment().endOf('days'));
                            }
                            _this.filterStateService.query = clearEmptyProperties(_this.filterStateService.query);
                            _this.filterStateService.onChangeFilter.next();
                        });
                        this.filterStateService.onClearFilter.pipe(tap(function () {
                            _this.filtersForm.reset();
                            _this.filtersForm.get('openedAtLte').setValue(moment().endOf('days'));
                            _this.filtersForm.get('openedAtGte').setValue(moment().subtract('1', 'month').startOf('days'));
                        })).subscribe();
                        return [2 /*return*/];
                }
            });
        });
    };
    FiltersComponent.prototype.getPropertyValue = function (value, array, property) {
        var item = array.find(function (a) { return a.id === value; });
        return item[property];
    };
    return FiltersComponent;
}());
export { FiltersComponent };
